import { Waves, Anchor, UtensilsCrossed, Martini, Bath, Palmtree, Flower2, Flame } from "lucide-react";
import { FACILITIES } from "@/lib/site";

const ICONS = { Waves, Anchor, UtensilsCrossed, Martini, Bath, Palmtree, Flower2, Flame };

export default function Facilities() {
  return (
    <section id="facilitati" data-testid="facilities-section" className="relative py-24 lg:py-36 px-5 lg:px-10 bg-[#012a2d] text-[#fcf3e6] overflow-hidden">
      {/* Decorative leaves */}
      <div className="absolute top-10 right-10 w-40 h-40 opacity-10 animate-float-y">
        <Palmtree className="w-full h-full text-[#048a93]" strokeWidth={0.5} />
      </div>
      <div className="absolute bottom-10 left-10 w-32 h-32 opacity-10 animate-float-y-rev">
        <Flower2 className="w-full h-full text-[#d4b895]" strokeWidth={0.5} />
      </div>

      <div className="max-w-7xl mx-auto relative">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-6">
            <div className="text-[#048a93] uppercase text-[11px] tracking-[0.32em] font-semibold mb-5">
              <span className="inline-block h-px w-10 bg-[#048a93] align-middle mr-3" />
              Facilități
            </div>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05]" data-testid="facilities-title">
              Un singur loc, tot ce ai nevoie<br />
              pentru o <span className="italic text-[#048a93]">zi perfectă</span>.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:pt-8">
            <p className="font-sans-ui text-[#fcf3e6]/75 text-lg leading-relaxed max-w-xl">
              De la piscină la grătarul din curte, fiecare element este gândit pentru ca tu și invitații tăi să vă bucurați de un eveniment fără griji.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {FACILITIES.map((f, idx) => {
            const Icon = ICONS[f.icon] || Waves;
            return (
              <div
                key={f.title}
                data-testid={`facility-card-${idx}`}
                className="group relative bg-[#fcf3e6]/[0.04] hover:bg-[#fcf3e6]/[0.08] border border-[#fcf3e6]/10 hover:border-[#048a93] rounded-3xl p-7 transition-all duration-500 hover:-translate-y-2"
              >
                <div className="h-14 w-14 rounded-2xl bg-[#048a93]/15 group-hover:bg-[#048a93] flex items-center justify-center mb-6 transition-all duration-500">
                  <Icon className="h-7 w-7 text-[#048a93] group-hover:text-[#fcf3e6] transition-colors" strokeWidth={1.5} />
                </div>
                <h3 className="font-serif-display text-2xl text-[#fcf3e6] mb-2 leading-tight">{f.title}</h3>
                <p className="font-sans-ui text-sm text-[#fcf3e6]/65 leading-relaxed">{f.desc}</p>
                <div className="absolute top-6 right-6 text-[#fcf3e6]/20 font-serif-display text-xs">
                  0{idx + 1}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
